import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import { Context } from '../../../app-contexts/CommonContexts';
import { useContext } from "react";
import ReactPaginate from "react-paginate";


const ProductPriceChanges = ({
    multiplePriceList,
    RemovePrice,
    Disabled
}) => {

    const {
        txnDecimalAmt
    } = useContext(Context);

    const [postsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = multiplePriceList.slice(indexOfFirstPost, indexOfLastPost)

    useEffect(() => { setCurrentPage(1) }, [multiplePriceList])

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <React.Fragment>
            <Row>
                <Col sm={12} md={6} className="mb-12-sm">
                    <div className="table-responsive">
                        <table className="table table-bordered  table-sm rounded  mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Date</th>
                                    <th style={{ textAlign: "right" }}>Cost Price</th>
                                    <th style={{ textAlign: "right" }}>Selling Price</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPosts.map((item, index) => {
                                    const rowNumber = indexOfFirstPost + index
                                    return (
                                        <tr key={index} className="p-0 m-0">
                                            <td>
                                                <h5 className="font-size-12 mb-0">{rowNumber+1}</h5>
                                            </td>
                                            <td>
                                                <h5 className="font-size-12 mb-0">{item.date.slice(0, 10)}</h5>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <h5 className="font-size-12 mb-0">{parseFloat(item.cost).toFixed(txnDecimalAmt)}</h5>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <h5 className="font-size-12 mb-0">{parseFloat(item.selling).toFixed(txnDecimalAmt)}</h5>
                                            </td>
                                            <td>
                                                <Button color="danger" size="sm" disabled={Disabled} className="btn-rounded" onClick={() => RemovePrice(rowNumber)}>Delete</Button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
            <Row>
                {multiplePriceList.length > 0 ? <Col sm={12} md={6} className="mb-12-sm">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(multiplePriceList.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-center pagination-sm'}
                    />
                </Col> : null}
            </Row>
        </React.Fragment>
    )
}

export default ProductPriceChanges

